
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(tz);

const hktime = (date?: string | Date | dayjs.Dayjs | null) => date ? dayjs.tz(date, 'Asia/Hong_Kong') : undefined;
const tomorrow = (date?: string | Date | dayjs.Dayjs | null) => dayjs.tz(date, 'Asia/Hong_Kong').add(1, 'day');

export default {
    today: () => dayjs().tz('Asia/Hong_Kong'),
    tomorrow,
    hktime,
}